/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserProfile } from './UserProfile';
import { UserProfileFromJSON, UserProfileFromJSONTyped, UserProfileToJSON } from './UserProfile';

/**
 *
 * @export
 * @interface CalvinUser
 */
export interface CalvinUser {
  /**
   *
   * @type {number}
   * @memberof CalvinUser
   */
  readonly id: number;
  /**
   * Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only.
   * @type {string}
   * @memberof CalvinUser
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof CalvinUser
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof CalvinUser
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof CalvinUser
   */
  readonly email: string;
  /**
   *
   * @type {UserProfile}
   * @memberof CalvinUser
   */
  calvinProfile: UserProfile;
}

/**
 * Check if a given object implements the CalvinUser interface.
 */
export function instanceOfCalvinUser(value: object): value is CalvinUser {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('username' in value) || value['username'] === undefined) return false;
  if (!('email' in value) || value['email'] === undefined) return false;
  if (!('calvinProfile' in value) || value['calvinProfile'] === undefined) return false;
  return true;
}

export function CalvinUserFromJSON(json: any): CalvinUser {
  return CalvinUserFromJSONTyped(json, false);
}

export function CalvinUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalvinUser {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    username: json['username'],
    firstName: json['first_name'] == null ? undefined : json['first_name'],
    lastName: json['last_name'] == null ? undefined : json['last_name'],
    email: json['email'],
    calvinProfile: UserProfileFromJSON(json['calvin_profile']),
  };
}

export function CalvinUserToJSON(value?: Omit<CalvinUser, 'id' | 'email'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    username: value['username'],
    first_name: value['firstName'],
    last_name: value['lastName'],
    calvin_profile: UserProfileToJSON(value['calvinProfile']),
  };
}
